import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'bv-components';

import Link from './link';

const LinkItemSingle = ({
  className, href, icon, small, iconClassName, label,
}) => (
  <Link className={className} href={href}>
    {icon && <Icon id={icon} big={!small} className={iconClassName} />}
    {label}
  </Link>
);

LinkItemSingle.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  small: PropTypes.bool,
  className: PropTypes.string.isRequired,
  iconClassName: PropTypes.string.isRequired,
};

LinkItemSingle.defaultProps = {
  small: false,
};

export default LinkItemSingle;
